























































import {
  Carousel,
  Slide,
} from 'vue-carousel';
import {
  Component,
  Vue,
} from 'vue-property-decorator';

import bButton from 'bootstrap-vue/es/components/button/button';
import bImg from 'bootstrap-vue/es/components/image/img';
import bContainer from 'bootstrap-vue/es/components/layout/container';
import bLink from 'bootstrap-vue/es/components/link/link';

import DEMO_DATA from '@/demo-data';

@Component({
  components: {
    Carousel,
    Slide,

    bButton,
    bContainer,
    bImg,
    bLink,
  },
})
export default class BrandSlide extends Vue {
  public readonly brands = DEMO_DATA.brands;

  get slidesPerPage() {
    return [
      [576, 2],
      [768, 3],
      [992, 4],
      [1200, 5],
    ];
  }
}

